module.exports = __webpack_public_path__ + "static/media/down-arrow.36b4fda8.svg";